/* eslint-disable react-hooks/exhaustive-deps */
import { Divider, Select } from 'antd';
import { WidgetLoader } from 'datastake-daf/dist/components';
import React, { useEffect, useMemo, useState } from 'react';
import Loading from '../../../Loading';
import { DropDown } from './style';
import { useNodes } from './useNodes';
import { getPopupContainer } from '../../../../helpers/popUp';

export const useSupplyChainMap = ({
  data = {},
  sources = [],
  defaultSources = [],
  trade = [],
  callback = () => { },
  title = '',
  type = 'default',
  setReports = null,
  defaultActive = null,
  disabledIds,
  projectData = {},
  t = (s) => s,
  setPopoverVisible = () => { },
}) => {
  const [activeSources, setActiveSources] = useState(defaultSources);
  const [activeItemToFocus, setActiveItemToFocus] = useState(defaultActive);
  const [flow, setFlow] = useState('LR');
  const [isLoading, setIsLoading] = useState(false)
  const [elementData, setElementData] = useState(data);

  const informationSources = useMemo(() =>
    sources.filter((s) => s.type === 'informationSource'), [sources]);

  const supplyChainActors = useMemo(() =>
    sources.filter((s) => s.type === 'supplyChainActor'), [sources]);

  const ownDataSources = useMemo(() =>
    sources.filter((s) => s.type === 'ownData'), [sources]);

  useEffect(() => {
    if (activeItemToFocus) {
      setIsLoading(true);
      callback(activeItemToFocus)
        .then((res) => {
          if (res.data && Object.keys(res.data).length) {
            setElementData(res.data);
          } else {
            setElementData({});
          }
          setIsLoading(false);
        }).catch(err => {
          setElementData({});
          setIsLoading(false);
        })
    } else {
      setElementData({});
      setIsLoading(false);
    }
  }, [activeItemToFocus, activeSources])

  const {
    elements,
    onConnect,
    onElementsRemove,
    onLoad,
    reports,
  } = useNodes({
    data: elementData,
    disabledIds,
    projectData,
    setPopoverVisible,
    flow,
    type,
    activeSources,
    supplyChainActors,
    informationSources,
    ownDataSources,
    t,
  });

  useEffect(() => {
    if (setReports) {
      setReports(reports);
    }
  }, [reports]);

  useEffect(() => {
    if (activeSources.length > 1) {
      setActiveSources(defaultSources);
    }
  }, [sources]);

  const itemsToFocus = useMemo(() => {
    if (trade && Array.isArray(trade) && trade.length) {
      return trade.map((i) => ({
        value: i.datastakeId,
        label: i.name,
      }));
    }
    return [];
  }, []);

  const getHeader = () => {
    switch (type) {
      case 'default':
        return (
          <Divider orientation="left">
            {t(title)}
            <DropDown>
              <label>{t('Focus')}</label>
              <Select
                {...getPopupContainer()}
                value={activeItemToFocus}
                onChange={(val) => setActiveItemToFocus(val)}
                style={{ width: 200 }}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {itemsToFocus.map((item, i) => (
                  <Select.Option value={item.value} key={`to-focus-${i + 1}`}>{item.label}</Select.Option>
                ))}
              </Select>
            </DropDown>
          </Divider>
        );
      default:
        return null;
    }
  };

  const margin = useMemo(() => {
    if (type) {
      switch (type) {
        case 'default':
          return '0 auto 20px auto';
        case 'SC_PROJECT':
          return '0px auto';
        default:
      }
    }
    return '0px';
  }, [type]);

  const loader = useMemo(() => {
    switch (type) {
      case 'default':
      case 'SC_PROJECT':
        return <WidgetLoader background="rgba(255, 255, 255, 0.7)" />
      default:
        return <Loading />
    }
  }, [type]);


  return {
    getHeader,
    margin,
    loader,
    isLoading,
    onElementsRemove,
    onConnect,
    onLoad,
    flow,
    setFlow,
    elements,
  };
}
